import { FC } from "react"
import classes from "./styles.module.scss"
import { classNames } from "@/shared/lib/helpers/classNames"
import { toRem } from "@/shared/lib/helpers/toRem"

interface AnchorProps {
	href: string
	className?: string
	children: React.ReactNode
	leftSection?: React.ReactNode
	rightSection?: React.ReactNode
	gapX?: number
	gapY?: number
	target?: string
	rel?: string
}

export const Anchor: FC<AnchorProps> = ({
	children,
	leftSection,
	rightSection,
	className,
	href,
	gapX,
	gapY,
	target,
	rel,
}) => {
	return (
		<a
			href={href}
			className={classNames([classes.anchor, className])}
			style={{
				"--gap-x": gapX ? toRem(gapX) : toRem(8),
				"--gap-y": gapY ? toRem(gapY) : toRem(8),
			}}
			target={target}
			rel={rel}
		>
			{leftSection && (
				<div className={classNames([classes.leftSection, classes.section])}>{leftSection}</div>
			)}
			{children}
			{rightSection && (
				<div className={classNames([classes.rightSection, classes.section])}>{rightSection}</div>
			)}
		</a>
	)
}
